import {Service, Application, HttpManager, Managers} from '@levelapp/softfabric';
import {getToken} from "../Common/Utils/token.utils";

export default class UsersService extends Service
{
    httpClient = Application.current.resolve<HttpManager>(Managers.HTTP_MANAGER);
    auth: any = Application.current.resolve(Managers.AUTH_MANAGER);

    async getAll(callback: Function, onFailure: Function)
    {
        const token = getToken();
        this.httpClient.addCustomHeader("Authorization", `Bearer ${token}`);
        this.httpClient.get("api/user", []).then((response: any) =>
        {
            if (response !== undefined)
            {
                callback(response.data.data);
                return;
            }

            onFailure();
        });
    }
}